<div class="remove-invoice-dialog">
  <h2 mat-dialog-title>Remove Invoice</h2>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form">
      <div class="invoice-details">
        <h3>Invoice Details</h3>
        <p><strong>Invoice Number:</strong> {{ data.invoice.billingNumber }}</p>
        <p><strong>Amount:</strong> {{ data.invoice.totalDue | currency:'R ':'symbol':'1.2-2' }}</p>
        <p><strong>Date:</strong> {{ data.invoice.issueDate | date:'medium' }}</p>
        <p><strong>Status:</strong>
          <mat-chip [class]="data.invoice.outstandingBalance <= 0 ? 'green-chip' : 'red-chip'">
            {{ data.invoice.outstandingBalance <= 0 ? 'Paid' : 'Outstanding' }} </mat-chip>
        </p>

        <!-- Payment Warning -->
        <div *ngIf="hasPayments" class="payment-warning">
          <div class="warning-content">
            <h4>⚠️ This invoice has associated payments!</h4>
          </div>
        </div>
      </div>

      <div class="action-selection">
        <h3>Select Action</h3>
        <mat-radio-group formControlName="action" (change)="onActionChange($event)">
          <!-- No payments - normal options -->
          <ng-container *ngIf="!hasPayments">
            <mat-radio-button value="remove" class="action-option">
              <div class="option-content">
                <div class="option-title">Remove Invoice</div>
                <div class="option-description">Mark this invoice as removed. It will remain visible in the list but
                  marked as removed with the reason provided.</div>
              </div>
            </mat-radio-button>

            <mat-radio-button value="removeAndRecreate" class="action-option">
              <div class="option-content">
                <div class="option-title">Remove & Recreate</div>
                <div class="option-description">Remove this invoice and open the dispute form with all details
                  pre-filled for recreation.</div>
              </div>
            </mat-radio-button>
          </ng-container>

          <!-- Has payments - restricted options -->
          <ng-container *ngIf="hasPayments">
            <mat-radio-button value="remove" class="action-option">
              <div class="option-content">
                <div class="option-title">Remove Invoice (Keep Payments)</div>
                <div class="option-description">Mark this invoice as removed but keep the payment records. The payments will remain in the system for financial reporting.</div>
              </div>
            </mat-radio-button>

            <mat-radio-button value="removeAndRecreate" class="action-option">
              <div class="option-content">
                <div class="option-title">Remove & Recreate (Keep Payments)</div>
                <div class="option-description">Remove this invoice and open the invoice form with all details pre-filled for recreation. Payment records will be preserved.</div>
              </div>
            </mat-radio-button>

            <mat-radio-button value="removeWithPayments" class="action-option dangerous-option">
              <div class="option-content">
                <div class="option-title">⚠️ Remove Invoice & Payments (DANGEROUS)</div>
                <div class="option-description">This will remove the invoice AND all associated payment records. This
                  action cannot be undone and may affect financial reporting.</div>
              </div>
            </mat-radio-button>

            <mat-radio-button value="removeWithPaymentsAndRecreate" class="action-option dangerous-option">
              <div class="option-content">
                <div class="option-title">⚠️ Remove Invoice & Payments & Recreate (DANGEROUS)</div>
                <div class="option-description">This will remove the invoice AND all associated payment records, then open the invoice form for recreation. This action cannot be undone and may affect financial reporting.</div>
              </div>
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </div>

      <div class="reason-section">
        <h3>Reason for Removal</h3>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Please provide a detailed reason for removing this invoice</mat-label>
          <textarea matInput formControlName="reason" rows="4"
            placeholder="e.g., Invoice created with incorrect patient details, wrong billing codes used, etc.">
      </textarea>
          <mat-error *ngIf="form.get('reason')?.hasError('required')">
            Reason is required
          </mat-error>
          <mat-error *ngIf="form.get('reason')?.hasError('minlength')">
            Reason must be at least 10 characters long
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()">Cancel</button>
    <!-- <button mat-stroked-button color="accent" (click)="onTestPrefill()" matTooltip="Test the prefill functionality without deleting the invoice">
      <mat-icon>science</mat-icon>
      Test Prefill
    </button> -->
    <button mat-raised-button [color]="isDangerousAction ? 'warn' : 'primary'" (click)="onConfirm()"
      [disabled]="!isFormValid">
      <ng-container [ngSwitch]="form.get('action')?.value">
        <span *ngSwitchCase="'remove'">{{ hasPayments ? 'Remove Invoice (Keep Payments)' : 'Remove Invoice' }}</span>
        <span *ngSwitchCase="'removeAndRecreate'">{{ hasPayments ? 'Remove & Recreate (Keep Payments)' : 'Remove & Recreate' }}</span>
        <span *ngSwitchCase="'removeWithPayments'">⚠️ Remove Invoice & Payments</span>
        <span *ngSwitchCase="'removeWithPaymentsAndRecreate'">⚠️ Remove Invoice & Payments & Recreate</span>
        <span *ngSwitchCase="'cancel'">Cancel</span>
        <span *ngSwitchDefault>Remove Invoice</span>
      </ng-container>
    </button>
  </mat-dialog-actions>
</div>